'use strict';
var FunderstormsHeader = React.createClass({
    render:function() {
        return (
            <header>
                <nav role="navigation" className="navbar navbar-default">
                    <input id="burger" data-toggle="collapse" data-target=".navbar-ex1-collapse" type="image" src="img/burger.svg" className="navbar-toggle"/>
                    <a href="#" tabIndex="-1" className="navbar-brand"><img src="img/logo.svg"/></a>
                    <div id="header_menu" className="collapse navbar-collapse navbar-ex1-collapse no-transition"></div>
                    <ul id="language_menu" className="nav navbar-nav">
                        <li><a href="/ru.html" tabIndex="-1">Rus</a></li>
                        <li><a href="/" tabIndex="-1">En</a></li>
                    </ul>
                </nav>
            </header>
        )}
});

var FunderstormsAboutUs = React.createClass({
    render:function() {
        return (
            <section className="game right" id="about_us">
                <ul className="fireman first elena" id="elena_first"><li><div></div></li><li><div></div></li></ul>
                <h3>{lang.about_us.name_game}</h3>
                <h2>{lang.about_us.name_section}</h2>
                <CrosswordGame />
            </section>
        )}
});

var FunderstormsOurClients = React.createClass({
    render:function() {
        return (
            <section className="game left" id="our_clients">
                <ul className="fireman first jorge" id="jorge_first"><li><div></div></li><li><div></div></li></ul>
                <h3>{lang.our_clients.name_game}</h3>
                <h2>{lang.our_clients.name_section}</h2>
                <div id="find_word">
                    <FindWordGame />
                </div>
            </section>
        )}
});

var FunderstormsExperience = React.createClass({
    render:function() {
        return (
            <section className="game right" id="experience">
                <ul className="fireman second elena" id="elena_second"><li><div></div></li></ul>
                <h3>{lang.experience.name_game}</h3>
                <h2>{lang.experience.name_section}</h2>
                <p dangerouslySetInnerHTML={{__html: lang.experience.p}}></p>
                <div id="connect_the_dots">
                    <div id="connect_the_dots_canvas">
                        <DotsGame />
                    </div>
                    <small dangerouslySetInnerHTML={{__html: lang.experience.small}}></small>
                    <ul id="connect_the_dots_clients">
                        <li><a href="#"><img src="img/clients/ddb.svg"/></a></li>
                        <li><a href="#"><img src="img/clients/bbdo.svg"/></a></li>
                        <li><a href="#"><img src="img/clients/y&r.svg"/></a></li>
                        <li><a href="#"><img src="img/clients/TBWA.svg"/></a></li>
                        <li><a href="#"><img src="img/clients/leo_burnett.svg"/></a></li>
                        <li><a href="#"><img src="img/clients/publicis.svg"/></a></li>
                    </ul>
                </div>
                <div id="years25">{lang.experience.years}</div>
            </section>
        )}
});

var FunderstormsOurWork = React.createClass({
    render:function() {
        MemoryGameRendered = <MemoryGame inited={this.props.inited}/>;
        return (
            <section className="game left" id="our_work">
                <ul className="social_icons twice"><li className="icon-vimeo"><a href="https://vimeo.com/thefunderstorms" target="_blank"><span><img src="img/social/vimeo.svg"/></span></a></li><li className="icon-youtube"><a href="https://www.youtube.com/channel/UCvUAipEMVih-foHVzlYuwGw/featured" target="_blank"><span><img src="img/social/youtube.svg"/></span></a></li></ul>
                <h3>{lang.our_work.name_game}</h3>
                <h2>{lang.our_work.name_section}</h2>
                <p dangerouslySetInnerHTML={{__html: lang.our_work.p}}></p>
                <p style={{display: "none"}} dangerouslySetInnerHTML={{__html: lang.our_work.p2}}></p>
                <div className="center" id="memory_game_canvas">
                    {MemoryGameRendered}
                </div>
                <small dangerouslySetInnerHTML={{__html: lang.our_work.small}}></small>
            </section>
        )}
});

var FunderstormsWhereNext = React.createClass({
    getInitialState: function() {
        return {
            solved: false
        }
    },
    solve: function(){
        if(!this.state.solved)
            this.setState({solved: true});
    },
    render:function() {
        return (
            <section className="game right" id="where_next">
                <h3>{lang.where_next.name_game}</h3>
                <h2>{lang.where_next.name_section}</h2>
                <p dangerouslySetInnerHTML={{__html: lang.where_next.p}}></p>
                <div className="center" id="hangman_game_canvas">
                    <div className="center" id="hangman_game">
                        <HangmanGame  solved={this.state.solved}/>
                    </div>
                    <b className="skip_game" disabled={this.state.solved} onClick={this.solve}>{lang.skip_game}</b>
                </div>
            </section>
        )}
});
var FunderstormsContacts = React.createClass({
    render:function() {
        return (
            <section id="contacts" className="game">
                <h2>{lang.contacts.name_section}</h2>
                <p> {lang.contacts.p}</p>
                <div id="contact_form">
                    <ContactForm />
                </div>
                <div>
                    <img src="img/contacts.png" id="firemans"/>
                    <div>
                        <h3 dangerouslySetInnerHTML={{__html: lang.contacts.elena}}></h3>
                        <ul className="social_icons">
                            <li className="icon-facebook"><a href="http://facebook.com/nesuvorova" target="_blank"><span><img src="img/social/facebook.svg"/></span></a></li>
                            <li className="icon-vk"><a href="http://vk.com/nesuvorova" target="_blank"><span><img src="img/social/vk.svg"/></span></a></li>
                            <li className="icon-instagram"><a href="https://www.instagram.com/nesuvorova/" target="_blank"><span><img src="img/social/instagram.svg"/></span></a></li>
                            <li className="icon-linked_in"><a href="https://ru.linkedin.com/in/elena-suvorova-17333845/en" target="_blank"><span><img src="img/social/linked_in.svg"/></span></a></li>
                            <li className="icon-skype"><a href="skype:nesuvorova" target="_blank"><span><img src="img/social/skype.svg"/></span></a></li>
                            <li className="icon-mail"><a href="mailto:e.suvorova@thefunderstorms.com"><span><img src="img/social/mail.svg"/></span></a></li>
                        </ul>
                    </div>
                    <div>
                        <h3 dangerouslySetInnerHTML={{__html: lang.contacts.jorge}}></h3>
                        <ul className="social_icons">
                            <li className="icon-facebook"><a href="http://facebook.com/jorgeriera" target="_blank"><span><img src="img/social/facebook.svg"/></span></a></li>
                            <li className="icon-www"><a href="http://www.jorgerieraflores.com" target="_blank"><span><img src="img/social/www.svg"/></span></a></li>
                            <li className="icon-instagram"><a href="https://www.instagram.com/jorgerieraflores/" target="_blank"><span><img src="img/social/instagram.svg"/></span></a></li>
                            <li className="icon-linked_in"><a href="https://ru.linkedin.com/in/jorge-riera-3165aa28" target="_blank"><span><img src="img/social/linked_in.svg"/></span></a></li>
                            <li className="icon-skype"><a href="skype:jorgerieraflores.com" target="_blank"><span><img src="img/social/skype.svg"/></span></a></li>
                            <li className="icon-mail"><a href="mailto:j.riera@thefunderstorms.com"><span><img src="img/social/mail.svg"/></span></a></li>
                        </ul>
                    </div>
                </div>
            </section>
        )}
});

var Funderstorms = React.createClass({
    getInitialState: function() {
        return {
            find_word_init: false
        }
    },
    initMemoryGame: function(){
        if(this.state.find_word_init) return;
        this.setState({find_word_init: true});
    },
    componentDidMount: function() {

    },
    componentWillMount: function() {

    },
    render:function() {
        return (
            <div id="container">
                <FunderstormsHeader/>
                <FunderstormsAboutUs/>
                <FunderstormsOurClients/>
                <FunderstormsExperience/>
                <ul className="fireman second jorge" id="jorge_second"><li><div></div></li></ul>
                <FunderstormsOurWork inited={this.state.find_word_init}/>
                <ul className="fireman treed elena" id="elena_treed"><li><div></div></li></ul>
                <FunderstormsWhereNext/>
                <ul className="fireman treed jorge" id="jorge_treed"><li><div></div></li></ul>
                <FunderstormsContacts/>
            </div>
        )}
});

var FunderstormApp;

function body_ready() {
    console.log(document.querySelector('body > div'));
    FunderstormApp = ReactDOM.render(
        <Funderstorms />,
        document.querySelector('body > div')
    );
    resize();
    setTimeout(function(){
        resize();
    }, 150);

}

document.addEventListener("DOMContentLoaded", body_ready);